import React from 'react';
import { Box, Icon, Typography, Tooltip } from '@material-ui/core';
import { HealthSystemDomainUsersResultBusinessUnitResponse } from '../../api/HealthSystemApi';
import { BusinessUnitType } from '../../models/farm';
import { useStyles } from './styles';

type IProps = {
  unit: HealthSystemDomainUsersResultBusinessUnitResponse;
  cssClass?: string;
};

const BusinessUnitLabel: React.FC<IProps> = ({ unit, cssClass }) => {
  const classes = useStyles();

  const metadata = [unit.number, unit.address].filter(Boolean).join(' • ');

  const tooltipContent = (
    <Box>
      <Typography variant="body2" style={{ fontWeight: 'bold' }}>
        {unit.name}
      </Typography>
      {unit.number && <Typography variant="caption">Number: {unit.number}</Typography>}
      {unit.address && (
        <Typography variant="caption" display="block">
          Address: {unit.address}
        </Typography>
      )}
      {unit.role && (
        <Typography variant="caption" display="block">
          Role: {unit.role}
        </Typography>
      )}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="right">
      <Box className={`${cssClass} ${classes.compactContainer}`}>
        <Icon className={unit.type === BusinessUnitType.Veterinary ? classes.blue : classes.green}>
          {unit.type === BusinessUnitType.Veterinary ? 'medical_services' : 'home_work'}
        </Icon>
        <Box className={classes.textContainer}>
          <Typography variant="body2" className={classes.unitName}>
            {unit.name}
          </Typography>
          {metadata && (
            <Typography variant="caption" className={classes.metadata}>
              {metadata}
            </Typography>
          )}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default BusinessUnitLabel;
